module.exports = __webpack_public_path__ + "static/media/1612931165336.9a60a90d.jpg";